import Calendar from "../../component/calendar/Calendar";
import MCalendar from "../../component/mobile/calendar/MCalendar";


const CALENDAR=()=>{
  return(
    <div className="CALENDAR">
      {window.innerWidth>1000 && <Calendar/>}
      {window.innerWidth<1000 && <MCalendar/>}
    </div>
  )
}

export default CALENDAR;
 